import React from 'react';
import LCVProgressTracker from './LCVProgressTracker';
import LCVStageTable from './LCVStageTable';
import LCVTopBar from './LCVTopBar';
import LCVTutorPanel from './LCVTutorPanel';
import LCVViewBoard from './LCVViewBoard';

const LCVStaticLessonStage = ({
  metadata,
  progressData,
  phase,
  activeTerm,
  middleContent,
  tutorText,
  tutorAnimationProgress,
  tutorPaused = false,
  canPauseTutor = false,
  canSkipTutor = false,
  tutorFontSize,
  onTutorFontSizeChange,
  onPauseTutor,
  onResumeTutor,
  onSkipTutor,
  onReplayTutor,
  canReplayTutor = false,
  trackerMode,
  visualContent,
}) => {
  if (!progressData || !middleContent) return null;

  return (
    <LCVStageTable
      className="lcv-stage-table-static"
      topLeft={<LCVTopBar metadata={metadata} />}
      topCenter={<LCVProgressTracker data={progressData} phase={phase} mode={trackerMode} />}
      topRight={<div className="lcv-stage-empty" />}
      middleLeft={
        visualContent ? (
          <LCVViewBoard phase={phase} term={activeTerm} visualContent={visualContent} />
        ) : (
          <div className="lcv-stage-empty" />
        )
      }
      middleCenter={<div className="lcv-stage-middle-shell">{middleContent}</div>}
      middleRight={<div className="lcv-stage-empty" />}
      bottomLeft={<div className="lcv-stage-empty" />}
      bottom={
        tutorText ? (
          <LCVTutorPanel
            text={tutorText}
            phase={phase}
            animationProgress={tutorAnimationProgress}
            paused={tutorPaused}
            canPause={canPauseTutor}
            canSkip={canSkipTutor}
            fontSize={tutorFontSize}
            onFontSizeChange={onTutorFontSizeChange}
            onPause={onPauseTutor}
            onResume={onResumeTutor}
            onSkip={onSkipTutor}
            onReplay={onReplayTutor}
            canReplay={canReplayTutor}
          />
        ) : (
          <div className="lcv-stage-empty" />
        )
      }
    />
  );
};

export default LCVStaticLessonStage;
